module.exports = "https://static.wmbcdn.com/uniweb/images/5fa372d0f4c664d4d6adf96accb45319.svg";